import { styled } from 'goober';
import { useEffect, useState } from 'preact/hooks';

import { LoaderSvg } from '../../assets/svg/LoaderSvg';
import { IQuizItem } from '../../types/quiz';
import { validateEmail } from '../../utils/validations';
import { Button } from '../buttons/Button';
import { QuestionImage } from '../parts/QuestionImage';
import { QuestionText } from '../parts/QuestionText';

type Props = {
  item: IQuizItem;
  onSubmit: (value: string) => void;
};

export const EmailQuestion = ({ item, onSubmit }: Props) => {
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(false);
  const [email, setEmail] = useState('');

  const onInput = (e: Event) => {
    const value = (e.target as any)?.value;
    if (typeof value === 'string') {
      setEmail(value.trim());
    }
  };

  const submit = () => {
    onSubmit(email);
    setLoading(true);
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && valid) {
      submit();
    }
  };

  useEffect(() => {
    if (loading) {
      setTimeout(() => setLoading(false), 2000);
    }
  }, [loading])

  useEffect(() => {
    setValid(validateEmail(email));
  }, [email]);

  const buttonDisabled = !valid || loading;

  return (
    <Container>
      <QuestionImage item={item} email={true} />
      <QuestionText item={item} />
      <InputContainer className="q-email-cont">
        {item?.label && (
          <Label className="q-email-label" for="emailInput">
            {item.label}
          </Label>
        )}
        <Input
          id="emailInput"
          type="email"
          value={email}
          onInput={onInput}
          autocomplete="email"
          className="q-email-input"
          placeholder="Enter your email"
          onKeyPressed={handleKeyPress}
        />
      </InputContainer>
      <div style={{ height: '30px' }} />
      <Button className="q-cta-button" disabled={buttonDisabled} onClick={submit}>
        {loading ? <LoaderSvg/> : item.cta || 'Continue'}
      </Button>
      <div style={{ height: '30px' }} />
      {item.footnote && (
        <Row>
          {/* <img
            style={{ width: '100%', maxWidth: '40px' }}
            src=""
          /> */}
          <Note>{item.footnote}</Note>
        </Row>
      )}
    </Container>
  );
};

const Container = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const InputContainer = styled('div')`
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 350px;
  flex-direction: column;
`;

const Input = styled('input')`
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  line-height: 20px;
  padding: 15px 20px;
  background-color: #ffffff;
  border: none;
  border-bottom: 2px solid #02122e;
`;

const Label = styled('label')`
  font-weight: 600;
  font-size: 1rem;
  line-height: 20px;
`;

const Row = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Note = styled('span')`
  color: #54434e;
  font-size: 12px;
  font-weight: 600;
  line-height: 17px;
  margin-left: 0.5rem;
`;
